import { render } from "./HomeVolverArriba.vue?vue&type=template&id=7a051632&scoped=true"
import script from "./HomeVolverArriba.vue?vue&type=script&lang=js"
export * from "./HomeVolverArriba.vue?vue&type=script&lang=js"

import "./HomeVolverArriba.vue?vue&type=style&index=0&id=7a051632&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a051632"]])

export default __exports__